import { render, staticRenderFns } from "./learnPlan.vue?vue&type=template&id=24781fc1&scoped=true"
import script from "./learnPlan.vue?vue&type=script&lang=js"
export * from "./learnPlan.vue?vue&type=script&lang=js"
import style0 from "./learnPlan.vue?vue&type=style&index=0&id=24781fc1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24781fc1",
  null
  
)

export default component.exports